/**
 * Inline loading spinner. Inherits `currentColor` so it matches whatever
 * text/button color it sits inside.
 *
 *   <Spinner />                       // 1rem, currentColor
 *   <Spinner className="w-5 h-5" />   // custom size
 */
export function Spinner({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <svg
      className={`animate-spin ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
